import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import withSpellcheck from "../../../../form-inputs/shared/spell-check";
import UserGroup from "./user-group";

import { InputList } from "../../../../form-inputs/inputs";

import { EMPTY_USERGROUP } from "../lib/constants";

const SpellCheckInputList = withSpellcheck(InputList);

const Directions = (props) => {
    const addNew = () => {
        props.addItem("userGroups", { ...EMPTY_USERGROUP });
    };
    const updateItem = (value) => {
        props.updateItem("userGroups", value);
    };

    const userGroups = props.userGroups || [];
    const userGroupsForms = userGroups.map((userGroup, i) => {
        return (
            <UserGroup
                key={userGroup.key}
                data={userGroup}
                updateOnChange={updateItem}
                removeItem={props.removeItem}
            />
        );
    });

    return (
        <div className="directions">
            <h3>Directions</h3>
            <SpellCheckInputList
                name="directions"
                label="Text"
                defaultValue={props.directions}
                updateOnChange={props.updateOnChange}
                validation={{ type: "StringList" }}
            />

            <h4>User Group (i.e. Dosing Group, Age Group)</h4>
            {userGroupsForms}
            <div className="button-group">
                <button
                    name="newUserGroup"
                    className="button -primary -small"
                    onClick={addNew}
                >
                    <FontAwesomeIcon icon={faPlus} /> User group
                </button>
            </div>
        </div>
    );
};

export default Directions;
